import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'signature-tool-alert',
  templateUrl: './signature-tool-alert.component.html',
  styleUrls: ['./signature-tool-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignatureToolAlertComponent {
  @Input() fileAdded = false;
  @Input() isPdf = false;
}
